import { useNavigate, useParams } from 'react-router-dom';

const useEmailLogSearch = () => {
  const { emailLogId } = useParams();
  const navigate = useNavigate();

  const emailLogSelected = (selectedEmailLogId: string) => {
    // Check if already viewing this email
    if (emailLogId === selectedEmailLogId) {
      return;
    }
    void navigate(`/email-logs/${selectedEmailLogId}`);
  };

  return {
    emailLogId,
    emailLogSelected
  };
};

export default useEmailLogSearch;
